import { useAuth } from "@clerk/clerk-react"

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export function useClerkEndpoint() {
  const { getToken, isSignedIn } = useAuth()

  return async (path: string, init?: RequestInit) => {
    // Get token from Clerk using the "vivid" JWT template
    let token: string | null = null
    try {
      token = isSignedIn ? await getToken({ template: "vivid" }) : null
    } catch (error) {
      console.error("Error getting Clerk token:", error)
    }

    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      ...((init?.headers as Record<string, string>) || {}),
    }

    // Add Authorization header if token exists
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    // Construct full URL
    const url = path.startsWith("http")
      ? path
      : `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`

    return fetch(url, {
      ...init,
      headers,
    })
  }
}
